import { useEffect, useState } from 'react';
import axios from 'axios';
import { LayoutDashboard, Users, ShoppingBag } from 'lucide-react';
import { TOPICS, TOPIC_GROUPS, topicSection, isLive } from '@/lib/topics';

const API = process.env.REACT_APP_BACKEND_URL;

export const topicBadge = (s) => (s?.overdue ? `${s.overdue} overdue` : s?.open ? `${s.open} open` : s?.affected ? `${s.affected} affected` : null);

// Open the Buyers' Group dashboard and scroll to one stage's topics.
export const goToGroupStage = (onNavigate, key) => {
  onNavigate('community-landing');
  setTimeout(() => document.getElementById(`topic-group-${key}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 350);
};

// Buyers' Group menu: dashboard, two stage headings each with only its live topics, then the common tools.
export default function useGroupMenu(projectId, enabled) {
  const [summary, setSummary] = useState({});
  useEffect(() => {
    if (!projectId || !enabled) return;
    axios.get(`${API}/api/topics/${projectId}`)
      .then((r) => setSummary(Object.fromEntries(r.data.topics.map((t) => [t.key, t])))).catch(() => {});
  }, [projectId, enabled]);
  const entries = [{ type: 'item', id: 'community-landing', label: 'Group dashboard', icon: LayoutDashboard, hint: 'All topics at a glance' }];
  TOPIC_GROUPS.forEach((g) => {
    entries.push({ type: 'heading', key: g.key, label: g.label, hint: g.hint });
    const live = TOPICS.filter((t) => t.group === g.key && isLive(summary[t.key]));
    if (!live.length) entries.push({ type: 'empty', key: g.key });
    live.forEach((t) => entries.push({ type: 'item', id: topicSection(t.key), label: t.label, icon: t.icon, hint: t.hint, badge: topicBadge(summary[t.key]) }));
  });
  entries.push({ type: 'divider', key: 'tools' });
  entries.push({ type: 'item', id: 'us-directory', label: 'Members', icon: Users, hint: 'Who is in your group' });
  entries.push({ type: 'item', id: 'property-marketplace', label: 'Classifieds', icon: ShoppingBag, hint: 'Buy, rent or lease within the project' });
  return entries;
}
